import { defineStore } from 'pinia';
import ApiService from '@/services/ApiService';

export const useFeedStore = defineStore('feed',{
    state: () => ({
            feedItems: [],
            feedOptions: [
                { name: 'All' },
                { name: 'Product Updates' },
                { name: 'Announcements' },
                { name: 'Articles' },
                { name: 'Promotions' },
                { name: 'Webinars' },
                { name: 'People' }],
            filteredFeed: null,
            filterType: ''
        }),
    getters:{
        getFeedOptions () {
            return this.feedOptions;
        },
        getFilterType () {
            return this.filterType;
        }
    },
    actions:{
        async fetchFeed (route) {
            // get feed items to display
            return await ApiService.getFeed()
            .then(response => {
                this.feedItems = response.data.filter(item => item.localeID === 1);
                this.filterFeed(route);
            })
            .catch(error => {
                throw(error);
            });
        },
        filterFeed (filterType) {
            this.filterType = filterType;
            if (filterType === 'all' || filterType === undefined) {
                this.filteredFeed = this.feedItems;
            } else {
                console.log(this.feedItems);
                this.filteredFeed = this.feedItems.filter(item => item.type.replaceAll(' ', '-').toLowerCase() === filterType.replaceAll(' ', '-').toLowerCase());
            }
        }
    }
});